import React from 'react';
import Table from '../../common/TableFinancial';
import { connect } from 'react-redux';
import { changeSortState, REDUCER_NAME } from '../reducer';
import Const from './Const';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectDataOverviewByTicker;

const widths = {};

const schema = listColumn =>
  Object.keys(listColumn).map((item, index) => {
    const key = listColumn[item];
    if (key === 'ticker') widths[key] = 100;
  });

function TableFinancial(props) {
  const { listId, isLoading, changeSortState, sortState } = props;

  return (
    <Table
      listId={listId}
      onSort={changeSortState}
      sortState={sortState}
      isLoading={isLoading}
      getDataFromRedux={getDataFromRedux}
      hideColumns={Const.listHideColumn}
      listColumns={Const.listColumn}
      i18nTitleKey="topVolume.financial.financialHeader"
      schema={schema(Const.listColumn)}
      widths={widths}
    />
  );
}

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataOverviewTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableFinancial);
